import template from './driveway-type.jade';
import items from '../../../enums/driveway-type';

export default angular
  .module('cian.addForm.aboutObjectDrivewayType', ['cian.addForm.fieldTypeDropdown'])
  .directive('cianAfAboutObjectDrivewayType', () => ({
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.items = items;
    },
    controllerAs: 'drivewayType',
    template,
  })).name;
